import { OhsFilterList } from 'dashboard/topFilter/OhsFilterModels';
import { OhsTabKeyTypes } from 'global-components/tab/OhsTabModels';
import { ApiResListsType } from 'global-services/api/OhsApiModels';
import { OhsUser } from 'user/OhsUser';
import { OhsTime } from 'global-services/constants/OhsTimeModels';
import {
  OhsOverviewRecordField,
  OhsCategoryRecordField as OhsGlobalCategoryRecordField,
  OhsCategoryOtherRecordField as OhsGlobalCategoryOtherRecordField,
  OhsReferenceRecordField,
} from 'global-services/constants/record-field/OhsGlobalRecordFiled';
import {
  OhsContractorBusinessNameRecordField,
  OhsContractorBusinessNumberTypeRecordField,
  OhsContractorBusinessNumberRecordField,
  OhsCategoryRecordField as OhsContractorCategoryRecordField,
  OhsCategoryOtherRecordField as OhsContractorCategoryOtherRecordField,
} from 'contractor/models/OhsContractorRecordField';
import {
  OhsPositionRecordField,
  OhsEmailRecordField,
  OhsWorkerNameRecordField,
} from 'human-resource/models/OhsHumanResourceRecordField';

import {
  OhsInjmtTaskFrequencyType,
  OhsInjuryMgmtTemplateRecord,
} from './models/OhsInjuryMgmtRecord';

function updateInjuryMgmtFilter(
  user: OhsUser | undefined,
  tabKey: OhsTabKeyTypes | null,
  filter: OhsFilterList
) {
  const defaultFilter = new OhsFilterList(user, tabKey);
  let updateSortFilter = filter;
  const defaultFilterObj = defaultFilter.injuryMgmtModule;
  if (tabKey === OhsTabKeyTypes.Template) {
    updateSortFilter = {
      ...filter,
      injuryMgmtModule: {
        ...filter.injuryMgmtModule,
        template: {
          ...filter.injuryMgmtModule.template,
          workplaces: defaultFilterObj.template.workplaces,
        },
      },
    };
  }
  if (tabKey === OhsTabKeyTypes.Folder) {
    updateSortFilter = {
      ...filter,
      injuryMgmtModule: {
        ...filter.injuryMgmtModule,
        folder: {
          ...filter.injuryMgmtModule.folder,
          workplaces: defaultFilterObj.folder.workplaces,
        },
      },
    };
  }
  if (tabKey === OhsTabKeyTypes.Record) {
    updateSortFilter = {
      ...filter,
      injuryMgmtModule: {
        ...filter.injuryMgmtModule,
        record: {
          ...filter.injuryMgmtModule.record,
        },
      },
    };
  }
  return updateSortFilter;
}

export function parseListAllocations(
  injuryMgmtTemplateList: ApiResListsType<any[]> | null,
  allocationLists: any[] | null
): ApiResListsType<any[]> | null {
  const templateList = injuryMgmtTemplateList?.items ?? [];

  if (templateList.length > 0) {
    const templatesWithAllocations = templateList.map((item: OhsInjuryMgmtTemplateRecord) => {
      const templateRecord: OhsInjuryMgmtTemplateRecord = {
        ...item,
        subRows: [],
      };

      allocationLists?.forEach((allocItem: OhsInjuryMgmtTemplateRecord) => {
        const { allocationOf } = allocItem;

        if (item._id === allocItem._id) {
          templateRecord.subRows?.push(allocItem);
        }

        if (allocationOf && allocationOf._id === item._id) {
          templateRecord.subRows?.push(allocItem);
        }
      });

      return templateRecord;
    }) as any[];

    const updatedInjuryMgmtTemplateList = {
      ...injuryMgmtTemplateList,
      items: templatesWithAllocations,
    } as ApiResListsType<any[]>;

    return updatedInjuryMgmtTemplateList;
  }

  return null;
}
export const getFormattedTimeString = (
  obj: { hours: number; minutes: number } | undefined
): string => {
  if (!obj || obj.hours === undefined || obj.minutes === undefined) return '';
  const time = new OhsTime(obj.hours, obj.minutes).get12HourString();
  return time;
};

export const normalizeCheckboxData = (value: any): boolean | undefined => {
  if (value === false) return false;
  if (value && value.length > 0) return true;
  return undefined;
};
export const getInjuryMgmtTaskTypeLabel = (recurrence: any) => {
  const mode = recurrence === null ? OhsInjmtTaskFrequencyType.OneOff : recurrence?.mode;
  switch (mode) {
    case OhsInjmtTaskFrequencyType.Recurring:
      return 'Recurring - Fixed Frequency';
    case OhsInjmtTaskFrequencyType.UserDefined:
      return 'Recurring - User Define';
    case OhsInjmtTaskFrequencyType.OneOff:
      return 'One Off';
    default:
      return mode || '';
  }
};

export const DEFAULT_INCIDENT_LINKED_PROPERTY_PATHS = [
  { ...OhsReferenceRecordField, lock: true },
  OhsOverviewRecordField,
  OhsGlobalCategoryRecordField,
  OhsGlobalCategoryOtherRecordField,
];

export const DEFAULT_HR_LINKED_PROPERTY_PATHS = [
  { ...OhsWorkerNameRecordField, lock: true },

  OhsPositionRecordField,
  OhsReferenceRecordField,
  OhsEmailRecordField,
];

export const DEFAULT_CONTRACTOR_LINKED_PROPERTY_PATHS = [
  { ...OhsContractorBusinessNameRecordField, lock: true },
  OhsContractorBusinessNumberTypeRecordField,
  OhsContractorBusinessNumberRecordField,
  OhsContractorCategoryRecordField,
  OhsContractorCategoryOtherRecordField,
];

export default { updateInjuryMgmtFilter };
